import React, { Component } from 'react';
import { connect } from 'react-redux';

class ImageItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imageCacheUrl: false
        }
    }

    componentDidMount() {
        const {cache, img} = this.props;
        cache.get(img.id, img.url).then((cache) => {
            this.setState({imageCacheUrl: cache.data});
        }).catch(() => {
            this.setState({imageCacheUrl: img.url});
        })
    }

    componentWillUnmount() {}

    render() {
        const {imageWidth, imageHeight, onError} = this.props;

        return (
            <span className="imageWrapper" style={{width: `${imageWidth}px`, height: `${imageHeight}px`}}>
                {
                    this.state.imageCacheUrl && 
                    <img 
                        height={imageHeight} 
                        width={imageWidth} 
                        onError={onError} 
                        src={this.state.imageCacheUrl} 
                        alt=""
                    />
                }
            </span>
        )
    }
}

const ImageItemWithRedux = connect()(ImageItem);

export {ImageItemWithRedux as ImageItem};


// WEBPACK FOOTER //
// ./src/components/EventPage/print/ImageItem.jsx